import MonacoEditor from '@monaco-editor/react';

interface MonacoCodeEditorProps {
  value: string;
  onChange: (value: string) => void;
  height?: string;
  language?: string;
  placeholder?: string;
  theme?: 'vs-dark' | 'vs-light' | 'hc-black';
  readOnly?: boolean;
}

export function MonacoCodeEditor({
  value,
  onChange,
  height = '400px',
  language = 'plaintext',
  theme = 'vs-light',
  placeholder,
  readOnly = false,
}: MonacoCodeEditorProps) {
  return (
    <MonacoEditor
      className="min-h-[400px] w-full"
      height={height}
      width="100%"
      language={language}
      theme={theme}
      value={value}
      onChange={(val) => onChange(val ?? '')}
      options={{
        readOnly,
        overviewRulerBorder: false,
        tabSize: 8,
        placeholder: placeholder || 'Enter your text here',
        detectIndentation: false,
        insertSpaces: true,
        lineHeight: 22,
        padding: { top: 8, bottom: 8 },
        cursorStyle: 'line',
        wordWrap: 'on',
        cursorSurroundingLinesStyle: 'all',
        fontSize: 14,
        minimap: { enabled: false },
        scrollBeyondLastLine: false,
        lineNumbers: 'on',
        automaticLayout: true,
      }}
    />
  );
}
